<template>
	<v-row align="center" justify="space-around" class="flex-wrap">
		<v-col cols="12" v-if="isPortalView">
			<h2 class="text-center darkColor--text">{{ title }}</h2>
		</v-col>
		<v-col cols="12" v-else>
			<h2 class="text-center mb-5 darkColor--text">{{ title }}</h2>
		</v-col>
		<v-col
			class="flex-grow-0 flex-shrink-1 pa-0 elevation-0"
			v-bind:class="{ inactive: !score1 }"
			ref="score"
		>
			<h3 class="text-center primary--text pb-3">HUMAN RIGHTS</h3>
			<vue-ellipse-progress
				:progress=default1
				:thickness="20"
				:emptyColor="score1 ? 'transparent' : '#b1b3b2'"
				:color="score1 ? '#1E7C83' : '#b1b3b2'"
			>
			<!-- To be changed -->
				<v-img 
					:src="require('../assets/Global_Compact_HumanRights.svg')"
					max-width="120px"
				>
				</v-img>
			</vue-ellipse-progress>
			<h1 v-if="score1" class="primary--text" style="font-size: 2.7em;">{{Math.ceil(score1)}}%</h1>
			<h1 v-else class="primary--text" style="font-size: 2.7em;">-</h1>
			<!-- <div v-if="score1">
				<h5 v-if="score1<30" class="text-center red--text">Needs improvement</h5>
				<h5 v-else-if="score1 >= 30 && score1 < 55" class="text-center orangeButton--text">OK</h5>
				<h5 v-else-if="score1 >= 55 && score1 < 75" class="text-center green--text">Good</h5>
				<h5 v-else class="text-center success--text">Very good</h5>
			</div> -->
		</v-col>
		<v-col
			class="flex-grow-0 flex-shrink-1 pa-0 elevation-0"
			v-bind:class="{ inactive: !score2 }"			
			ref="score"
		>
			<h3 class="text-center primary--text pb-3">LABOUR</h3>
			<vue-ellipse-progress
				:progress=default2
				:thickness="20"
				:emptyColor="score2 ? 'transparent' : '#b1b3b2'"
				:color="score2 ? '#DE8F18' : '#b1b3b2'"
			>
			<!-- To be changed -->
				<v-img 
					:src="require('../assets/Global_Compact_Labour.svg')"
					max-width="120px"
				>
				</v-img>
			</vue-ellipse-progress>
			<h1 v-if="score2" class="primary--text" style="font-size: 2.7em;">{{Math.ceil(score2)}}%</h1>
			<h1 v-else class="primary--text" style="font-size: 2.7em;">-</h1>
			<!-- <div v-if="score2">
				<h5 v-if="score2<30" class="text-center red--text">Needs improvement</h5>
				<h5 v-else-if="score2 >= 30 && score2 < 55" class="text-center orangeButton--text">OK</h5>
				<h5 v-else-if="score2 >= 55 && score2 < 75" class="text-center green--text">Good</h5>
				<h5 v-else class="text-center success--text">Very good</h5>
			</div> -->
		</v-col>
		<v-col
			class="flex-grow-0 flex-shrink-1 pa-0 elevation-0"
			v-bind:class="{ inactive: !score3 }"
			ref="score"
		>
			<h3 class="text-center primary--text pb-3">ENVIRONMENT</h3>
			<vue-ellipse-progress
				:progress=default3
				:thickness="20"
				:emptyColor="score3 ? 'transparent' : '#b1b3b2'"
				:color="score3 ? '#1E7C83' : '#b1b3b2'"
			>
			<!-- To be changed -->
				<v-img 
					:src="require('../assets/Global_Compact_Environment.svg')"
					max-width="120px"
				>
				</v-img>
			</vue-ellipse-progress>
			<h1 v-if="score3" class="primary--text" style="font-size: 2.7em;">{{Math.ceil(score3)}}%</h1>
			<h1 v-else class="primary--text" style="font-size: 2.7em;">-</h1>
			<!-- <div v-if="score3">
				<h5 v-if="score3<30" class="text-center red--text">Needs improvement</h5>
				<h5 v-else-if="score3 >= 30 && score3 < 55" class="text-center orangeButton--text">OK</h5>
				<h5 v-else-if="score3 >= 55 && score3 < 75" class="text-center green--text">Good</h5>
				<h5 v-else class="text-center success--text">Very good</h5>
			</div> -->
		</v-col>
		<v-col
			class="flex-grow-0 flex-shrink-1 pa-0 elevation-0"
			v-bind:class="{ inactive: !score4 }"
			ref="score"
		>
			<h3 class="text-center primary--text pb-3">ANTICORRUPTION</h3>
			<vue-ellipse-progress
				:progress=default4
				:thickness="20"
				:emptyColor="score4 ? 'transparent' : '#b1b3b2'"
				:color="score4 ? '#DE8F18' : '#b1b3b2'"
			>
			<!-- To be changed -->
				<v-img 
					:src="require('../assets/Global_Compact_AntiCorruption.svg')"
					max-width="120px"
				>
				</v-img>
			</vue-ellipse-progress>
			<h1 v-if="score4" class="primary--text" style="font-size: 2.7em;">{{Math.ceil(score4)}}%</h1>
			<h1 v-else class="primary--text" style="font-size: 2.7em;">-</h1>
			<!-- <div v-if="score4">
				<h5 v-if="score4<30" class="text-center red--text">Needs improvement</h5>
				<h5 v-else-if="score4 >= 30 && score4 < 55" class="text-center orangeButton--text">OK</h5>
				<h5 v-else-if="score4 >= 55 && score4 < 75" class="text-center green--text">Good</h5>
				<h5 v-else class="text-center success--text">Very good</h5>
			</div> -->
		</v-col>
	</v-row>
</template>

<script>
import { VueEllipseProgress } from "vue-ellipse-progress"
export default {
	name: "SupplierCSR",
	props: {
		title: String,
		score1: Number,
		score2: Number,
		score3: Number,
		score4: Number,
		isPortalView: {
			type: Boolean,
			default: false
		}
	},
	components: { VueEllipseProgress },
	mounted() { },
	methods: {
	},
	computed: {
		default1() {
			return this.score1 || 100
		},
		default2() {
			return this.score2 || 100
		},
		default3() {
			return this.score3 || 100
		},
		default4() {
			return this.score4 || 100
		}
	},
}


</script>

<style scoped>
.inactive {
	-webkit-filter: grayscale(100%);
	-moz-filter: grayscale(100%);
	-o-filter: grayscale(100%);
	-ms-filter: grayscale(100%);
	filter: grayscale(100%);
}

.supplier-csr-header {
	display: flex;
	justify-content: center;
}
</style>
